import TagManager from "react-gtm-module";
import auth from "../components/Layout/util/auth";

export const callGTMCTAClick = (
  r,
  eventName,
  loggedInUserStatus,
  guestUserStatus,
  mobile,
  email,
  gaID,
  songName,
  pageName
) => {
  if (r?.token) {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        userStatus: loggedInUserStatus,
        mobile: mobile,
        email: email,
        gaID: gaID,
        songName: songName,
        pageName: pageName,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  } else {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        userStatus: guestUserStatus,
        mobile: mobile,
        email: email,
        gaID: gaID,
        songName: songName,
        pageName: pageName,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }
};

export const enquireNowGTMCTAClick = (
  r,
  eventName,
  loggedInUserStatus,
  guestUserStatus,
  ctaName,
  mobile,
  email,
  gaID,
  songName,
  pageName,
  question1,
  question2,
  question3,
  question4
) => {
  if (r?.token) {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        userStatus: loggedInUserStatus,
        ctaName: ctaName,
        mobile: mobile,
        email: email,
        gaID: gaID,
        songName: songName,
        pageName: pageName,
        question1: question1,
        question2: question2,
        question3: question3,
        question4: question4,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  } else {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        userStatus: guestUserStatus,
        ctaName: ctaName,
        mobile: mobile,
        email: email,
        gaID: gaID,
        songName: songName,
        pageName: pageName,
        question1: question1,
        question2: question2,
        question3: question3,
        question4: question4,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }
};

export const tokenBuyNowGTMClick = (
  r,
  eventName,
  tokenName,
  tokenCategory,
  tokenPrice,
  tokenOwnership,
  userStatus
) => {
  if (r?.token) {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        tokenName: tokenName,
        tokenCategory: tokenCategory,
        tokenPrice: tokenPrice,
        tokenOwnership: tokenOwnership,
        userStatus: userStatus,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  } else {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        tokenName: tokenName,
        tokenCategory: tokenCategory,
        tokenPrice: tokenPrice,
        tokenOwnership: tokenOwnership,
        userStatus: userStatus,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }
};

export const tokenAddFundsGTMClick = (
  r,
  eventName,
  tokenPrice,
  paymentGatewayProvider,
  currency,
  userStatus
) => {
  if (r?.token) {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        tokenPrice: tokenPrice,
        paymentGatewayProvider: paymentGatewayProvider,
        currency: currency,
        userStatus: userStatus,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  } else {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        tokenPrice: tokenPrice,
        paymentGatewayProvider: paymentGatewayProvider,
        currency: currency,
        userStatus: userStatus,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }
};

export const tokenAddFundsGTMfailure = (
  r,
  eventName,
  tokenName,
  tokenCategory,
  tokenPrice,
  tokenOwnership,
  loggedInUserStatus,
  guestUserStatus,
  paymentStatus
) => {
  if (r?.token) {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        tokenName: tokenName,
        tokenCategory: tokenCategory,
        tokenPrice: tokenPrice,
        tokenOwnership: tokenOwnership,
        userStatus: loggedInUserStatus,
        paymentStatus: paymentStatus,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  } else {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        tokenName: tokenName,
        tokenCategory: tokenCategory,
        tokenPrice: tokenPrice,
        tokenOwnership: tokenOwnership,
        userStatus: guestUserStatus,
        paymentStatus: paymentStatus,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }
};

export const tokenPurchaseGTMCallback = (
  r,
  eventName,
  paymentStatus,
  paymentGateway,
  currency,
  nftfinalPrice,
  tokenDetails,
  tokenOwnership,
  paymentId,
  mobile,
  email,
  gaID,
  tokenquantity
) => {
  if (paymentStatus == "SUCCESS") {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        paymentStatus: paymentStatus,
        paymentGateway: paymentGateway,
        currency: currency,
        mobile: mobile,
        email: email,
        gaID: gaID,
        ecommerce: {
          purchase: {
            actionField: {
              id: paymentId, // Transaction ID. Required for purchases and refunds.
              affiliation: "webSite",
              revenue: nftfinalPrice,
              tax: 0,
              shipping: 0,
              coupon: 0,
            },
            products: [
              {
                name: tokenDetails, // Name or ID is required.
                id: tokenDetails,
                price: nftfinalPrice,
                brand: "FanTiger",
                category: tokenDetails,
                variant: tokenOwnership,
                quantity: tokenquantity,
                coupon: 0,
              },
            ],
          },
        },
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }
};

export const songPageGTMCTAClick = (
  r,
  eventName,
  sourceName,
  ctaName,
  loggedInUserStatus,
  guestUserStatus,
  pageName = "Song Page"
) => {
  if (r?.token) {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        sourceName: sourceName,
        ctaName: ctaName,
        userStatus: loggedInUserStatus,
        pageName: pageName,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  } else {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        sourceName: sourceName,
        ctaName: ctaName,
        userStatus: guestUserStatus,
        pageName: pageName,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }
};
export const influencerPageGTMCTAClick = (
  r,
  eventName,
  sourceName,
  ctaName,
  loggedInUserStatus,
  guestUserStatus
) => {
  if (r?.token) {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        sourceName: sourceName,
        ctaName: ctaName,
        userStatus: loggedInUserStatus,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  } else {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        sourceName: sourceName,
        ctaName: ctaName,
        userStatus: guestUserStatus,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }
};

export const reachUsGTMCTAClick = (
  r,
  eventName,
  sourceName,
  ctaName,
  loggedInUserStatus,
  guestUserStatus,
  pageName,
  gaID
) => {
  if (r?.token) {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        sourceName: sourceName,
        ctaName: ctaName,
        userStatus: loggedInUserStatus,
        pageName: pageName,
        gaID: gaID,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  } else {
    const tagManagerArgs = {
      dataLayer: {
        event: eventName,
        sourceName: sourceName,
        ctaName: ctaName,
        userStatus: guestUserStatus,
        pageName: pageName,
        gaID: gaID,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }
};
